module.exports = __webpack_public_path__ + "static/media/logo-new.2dc2440f.svg";